<template>
  {{ outputValue }}
</template>

<script lang="ts">
import { numberFormatter } from "@/func/format/numberFormat";
import { Dict, SfNumberFormatter } from "@/types/generalTypes";
import { defineComponent, PropType } from "vue";

export default defineComponent({
  components: {},
  props: {
    value: { type: Number, required: true },
    format: { type: Object as PropType<Dict<any>> },
  },
  data() {
    return {
      formatter: null as SfNumberFormatter | null,
    };
  },
  mounted() {
    if (this.format) {
      this.formatter = numberFormatter(this.format);
    }
  },
  computed: {
    outputValue() {
      if (this.formatter) {
        return this.formatter.format(this.value);
      }
      return this.value;
    },
  },
});
</script>
